import {PublicKey, TransactionInstruction} from "@solana/web3.js";
import {getOrCreateAssociatedTokenAccount, TOKEN_PROGRAM_ID} from "@solana/spl-token";
import { LAMPORTS_PER_SOL} from '@solana/web3.js';

import {solana} from '@web3modal/solana/chains';
import {connection} from '../../utils/connection';
// SPL mint addresses (mainnet)
const USDT_MINT_ADDRESS = 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB';
const USDC_MINT_ADDRESS = 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v';
const MEMO_PROGRAM_ID = new PublicKey("MemoSq4gqABAXKb96qnH8TysNcWxMyWCqXgDLGmfcHr");


// For wallet Connect modal config
export const chains = [solana];
export const projectId = '19bcd68b0a6d5ed2f17caebebd775ae6';
export const metadata = {
    name: 'PrismaxAI',
    description: 'PrismaxAI',
    url: 'https://app.prismax.ai',
    icons: ['https://app.prismax.ai/favicon.svg']
};



export const fetchBalancesAndNotifyParent = async (
    provider,
    publicKey,
    onWalletConnected,
    showNotification
) => {
    try {
        const userPubkey = new PublicKey(publicKey);

        const lamports = await connection.getBalance(userPubkey);
        const solBalance = lamports / LAMPORTS_PER_SOL;

        if (solBalance <= 0) {
            showNotification(
                'error',
                'Please connect a wallet with a positive SOL balance or log in with your email to continue.'
            );
            return false;
        }

        const payer = {
            publicKey: userPubkey,
            signTransaction: async (tx) => provider.signTransaction(tx),
        };

        let usdcBalance = 0;
        let usdtBalance = 0;

        try {
            const usdcAccount = await getOrCreateAssociatedTokenAccount(
                connection,
                payer,
                new PublicKey(USDC_MINT_ADDRESS),
                userPubkey
            );
            usdcBalance = Number(usdcAccount.amount) / 1_000_000;
        } catch (err) {
            console.error('Error fetching USDC balance:', err);
        }

        try {
            const usdtAccount = await getOrCreateAssociatedTokenAccount(
                connection,
                payer,
                new PublicKey(USDT_MINT_ADDRESS),
                userPubkey
            );
            usdtBalance = Number(usdtAccount.amount) / 1_000_000;
        } catch (err) {
            console.error('Error fetching USDT balance:', err);
        }

        onWalletConnected?.(publicKey, usdtBalance, usdcBalance);

        return true; // ✅
    } catch (err) {
        console.error('Error fetching balances:', err);
        showNotification?.('error', 'Failed to fetch wallet balances.');
        return false;
    }
};
// same as above function ,but instead of pass to parent hook , just pass 3 constant out
export const fetchTokenBalances = async (provider, publicKey) => {
    try {
        // const connection = new Connection(RPC_URL, "confirmed");
        const userPubkey = new PublicKey(publicKey);

        const payer = {
            publicKey: userPubkey,
            signTransaction: async (tx) => {
                return await provider.signTransaction(tx);
            }
        };

        let usdcBalance = 0;
        let usdtBalance = 0;
        // USDC
        try {
            const usdcMintPubkey = new PublicKey(USDC_MINT_ADDRESS);
            const usdcAccount = await getOrCreateAssociatedTokenAccount(
                connection,
                payer,
                usdcMintPubkey,
                userPubkey
            );
            usdcBalance = Number(usdcAccount.amount) / 1_000_000;
        } catch (err) {
            console.error("Error fetching USDC balance:", err);
        }

        // USDT
        try {
            const usdtMintPubkey = new PublicKey(USDT_MINT_ADDRESS);
            const usdtAccount = await getOrCreateAssociatedTokenAccount(
                connection,
                payer,
                usdtMintPubkey,
                userPubkey
            );
            usdtBalance = Number(usdtAccount.amount) / 1_000_000;
        } catch (err) {
            console.error("Error fetching USDT balance:", err);
        }


        return {
            usdcBalance,
            usdtBalance,
        };
    } catch (err) {
        console.error("Error fetching balances:", err);
    }
};

export async function fetchThreeTokenBalancesWithoutProvider(walletAddressStr, onWalletConnected) {
    // const connection = new Connection(RPC_URL, "confirmed");
    let usdtBalance = 0;
    let usdcBalance = 0;
    let walletPublicKey
    try {
        walletPublicKey = new PublicKey(walletAddressStr);
        // 1) Get all token accounts owned by this wallet
        const response = await connection.getParsedTokenAccountsByOwner(
            walletPublicKey,
            {programId: new PublicKey("TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA")}
        );

        // 2) Initialize balances


        // 3) Loop through all token accounts, match the mint, parse its balance
        for (const {account} of response.value) {
            const info = account.data.parsed.info;
            const mint = info.mint;
            const amountStr = info.tokenAmount?.amount || "0";
            const decimals = info.tokenAmount?.decimals || 0;
            const parsedBalance = Number(amountStr) / 10 ** decimals;

            if (mint === USDT_MINT_ADDRESS) {
                usdtBalance = parsedBalance;
            } else if (mint === USDC_MINT_ADDRESS) {
                usdcBalance = parsedBalance;
            }
            if (onWalletConnected) {
                onWalletConnected(walletAddressStr, usdtBalance, usdcBalance);
            }
            return {usdtBalance, usdcBalance};
        }
    } catch (err) {
        console.error("Error fetching balances:", err);
        if (onWalletConnected) {
            onWalletConnected(walletAddressStr, usdtBalance, usdcBalance);
        }
        return {usdtBalance, usdcBalance};
    }

}

export const getTokenAccountFromWalletAddress = async (walletToQuery, mintAddress) => {
    try {
        const walletPubkey = new PublicKey(walletToQuery);
        const mintPubkey = new PublicKey(mintAddress);

        const tokenAccounts = await connection.getTokenAccountsByOwner(
            walletPubkey,
            { mint: mintPubkey }
        );

        if (tokenAccounts.value.length === 0) {
            console.log("No token account found");
            return null;
        }

        return tokenAccounts.value[0].pubkey.toBase58();

    } catch (error) {
        console.error("Error getting token account:", error);
        return null;
    }
};

export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function sleep2(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function addMemoInstruction(transaction, text) {
    const memoIx = new TransactionInstruction({
        keys: [],
        programId: MEMO_PROGRAM_ID,
        data: Buffer.from(text, 'utf8'),
    });
    transaction.add(memoIx);
}